<template>
  <v-dialog v-model="getDialog" :width="$vuetify.breakpoint.smAndDown ? '100%' : 500"
    :fullscreen="$vuetify.breakpoint.xs" persistent @keydown.esc="chiudi()" @keydown.ctrl.enter="formSubmit">
    <v-form ref="formIns" v-on:submit.prevent="formSubmit()" lazy-validation style="height:100%!important;">
      <v-card class="dialog-card d-flex flex-column" :class="{ 'dialog-mobile': $vuetify.breakpoint.smAndDown }"
        style="height:100%;">

        <v-card-title class="pa-0 flex-shrink-0">
          <div class="header-content" :style="{ backgroundColor: colorePerTipo(dati.tipoOre) }">
            <div class="header-row">

              <!-- Select tipo -->
              <div class="header-select-wrap">
                <v-avatar size="10" color="white" class="mr-2 flex-shrink-0" style="opacity:0.7;" />
                <v-select :items="tipiOre" v-model="dati.tipoOre" hide-details dense solo background-color="transparent"
                  class="tipo-select" @change="impostaDescrizione" color="black" />
              </div>

              <!-- Utente -->
              <div class="header-meta">
                <span style="font-size: 0.8em">{{ $functions.formatISODate(dati.data) }}</span>
                <span class="mx-1">·</span>
                <span>{{ utente }}</span>
              </div>

            </div>
          </div>
        </v-card-title>


        <v-card-text class="flex-grow-1 pa-3 pa-sm-4" style="overflow-y:auto;">
          <v-container fluid class="pa-0">
            <v-row dense>

              <!-- ── SEZIONE 1: Cliente e dettagli (solo per Lavoro) ── -->
              <template v-if="dati.tipoOre === 'Lavoro'">
                <v-col cols="12">
                  <div class="section-label">
                    <v-icon x-small class="mr-1">business</v-icon>Cliente e fatturazione
                  </div>
                </v-col>

                <!-- Cliente -->
                <v-col cols="12" class="mb-2">
                  <v-autocomplete :items="clienti" label="Cliente" item-text="ragSoc" item-value="ragSoc"
                    v-model="clienteSel" return-object ref="inputCliente" clearable dense outlined hide-details="auto"
                    v-on:change="setCliente()" />
                </v-col>

                <!-- Importo, Tipo importo, Destinazione -->
                <v-col cols="4">
                  <v-text-field v-model="dati.importo" label="Importo €" dense outlined hide-details="auto"
                    @focus="$event.target.select()" />
                </v-col>

                <v-col cols="4">
                  <v-select :items="tipiImporto" v-model="dati.tipoImporto" label="Tipo" dense outlined
                    hide-details="auto" />
                </v-col>

                <v-col cols="4">
                  <v-select :items="destinazioni" v-model="dati.destinazione" label="Destinazione" dense outlined
                    hide-details="auto" />
                </v-col>

                <!-- Checkbox fatturazione e trasferta come btn-toggle -->
                <v-col cols="12">
                  <div class="d-flex flex-wrap gap-8">
                    <v-btn small :outlined="!dati.daFatturare" :color="dati.daFatturare ? 'primary' : 'grey'"
                      :dark="dati.daFatturare" class="flag-btn" @click="dati.daFatturare = !dati.daFatturare">
                      <v-icon small class="mr-1">
                        {{ dati.daFatturare ? 'receipt' : 'receipt_long' }}
                      </v-icon>
                      Da fatturare
                    </v-btn>

                    <v-btn small :outlined="!dati.trasferta" :color="dati.trasferta ? 'indigo' : 'grey'"
                      :dark="dati.trasferta" class="flag-btn" @click="dati.trasferta = !dati.trasferta">
                      <v-icon small class="mr-1">
                        {{ dati.trasferta ? 'luggage' : 'work_outline' }}
                      </v-icon>
                      Trasferta
                    </v-btn>
                  </div>
                </v-col>
              </template>



              <!-- ── SEZIONE 2: Durata ── -->
              <v-col cols="4" class="mt-4">
                <div class="section-label">
                  <v-icon x-small class="mr-1">calendar_month</v-icon>Data
                </div>
              </v-col>

              <v-col cols="8" class="mt-4">
                <div class="section-label">
                  <v-icon x-small class="mr-1">timer</v-icon>Durata
                </div>
              </v-col>

              <v-col cols="4" class="mb-2">
                <v-text-field v-model="dati.data" label="Data" type="date" dense outlined hide-details="auto"
                  :rules="[rules.required]" />
              </v-col>


              <!-- Ore e Minuti -->
              <v-col cols="4">
                <v-text-field v-model="dati.ore" label="Ore" type="number" min="0" max="24" dense outlined
                  hide-details="auto" :rules="[rules.required, rules.oreValide]" @focus="$event.target.select()" />
              </v-col>

              <v-col cols="4">
                <v-text-field v-model="dati.minuti" label="Minuti" type="number" min="0" max="59" dense outlined
                  hide-details="auto" :rules="[rules.minutiValidi]" @focus="$event.target.select()" />
              </v-col>

              <!-- Totale calcolato -->
              <!--  <v-col cols="4" class="d-flex align-center">
                <div class="totale-ore" :style="{ color: colorePerTipo(dati.tipoOre) }">
                  <v-icon small :color="colorePerTipo(dati.tipoOre)" class="mr-1">schedule</v-icon>
                  {{ totaleOreLabel }}
                </div>
              </v-col> -->

              <!-- Chip durata rapida -->
              <!-- <v-col cols="12">
                <div class="durata-chips">
                  <span class="durata-label">Imposta:</span>
                  <v-chip v-for="d in durateRapide" :key="d.label" x-small outlined class="ml-1"
                    :color="colorePerTipo(dati.tipoOre)" @click="impostaDurata(d.ore, d.minuti)">{{ d.label }}</v-chip>
                  <span class="durata-label ml-3">Aggiungi:</span>
                  <v-chip v-for="d in durateAggiunta" :key="'add-' + d.label" x-small outlined class="ml-1" color="grey"
                    @click="aggiungiDurata(d.ore, d.minuti)">+{{ d.label }}</v-chip>
                </div>
              </v-col> -->

              <!-- ── SEZIONE 3: Descrizione ── -->
              <v-col cols="12" class="mt-4">
                <div class="section-label">
                  <v-icon x-small class="mr-1">notes</v-icon>Descrizione
                </div>
              </v-col>

              <v-col cols="12">
                <v-textarea outlined dense label="Descrizione" v-model="dati.descrizione" hide-details="auto" auto-grow
                  rows="2" @keydown.ctrl.enter.prevent="formSubmit" />
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />
        <v-card-actions class="flex-shrink-0 pa-3">
          <v-btn text @click="chiudi()">
            <v-icon small class="mr-1">close</v-icon>
            Annulla
          </v-btn>

          <v-btn text icon color="red lighten-1" @click="elimina" :disabled="prog == -1"
            v-tooltip.bottom="'Elimina evento'">
            <v-icon>delete_outline</v-icon>
          </v-btn>

          <v-spacer />

          <span v-if="!$vuetify.breakpoint.smAndDown" class="caption grey--text mr-2">
            Ctrl+↵ per salvare
          </span>

          <v-btn color="primary" type="submit">
            <v-icon small class="mr-1">save</v-icon>
            Salva
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {
  get_calendar,
  save_calendar,
  del_calendar,
} from "@/api/api.calendar.js";

import mixinCalendar from "@/views/calendar/mixinCalendar";

// Colori coerenti con quelli usati nel calendario
const COLORI_TIPO = {
  Lavoro: 'var(--primary)',
  Ferie: '#F9A825',
  Permesso: '#FFA000',
  Mutua: '#e91e8e',
  Trasferta: '#303F9F',
  Corso: '#512DA8',
  'Visita medica': '#00838F',
};

const ICONE_TIPO = {
  Lavoro: 'work',
  Ferie: 'beach_access',
  Permesso: 'event_busy',
  Mutua: 'local_hospital',
  Trasferta: 'flight',
  Corso: 'school',
  'Visita medica': 'medical_services',
};

export default {
  props: {
    dialog: { type: Boolean, default: false },
    data: { type: String, default: "" },
    prog: { type: Number, default: 0 },
    clienti: { type: Array, default: () => [] },
    utente: { type: String, default: "" },
    // Voce da cui precompilare il form quando prog === -1 e si tratta di una duplicazione
    // (per un inserimento "vuoto" normale resta null)
    sorgente: { type: Object, default: null },
  },

  mixins: [mixinCalendar],

  data: () => ({
    dati: {},

    clienteSel: {},
    tipiImporto: ["Orario", "Totale"],
    destinazioni: ["Cliente", "Ufficio"],
    tipiOre: ["Lavoro", "Ferie", "Permesso", "Mutua", "Trasferta", "Corso", "Visita medica"],
    desc: ["Modifiche software", "Ferie", "Permesso", "Mutua", "Trasferta", "Corso", "Visita medica"],

    durateRapide: [
      { label: '4h', ore: 4, minuti: 0 },
      { label: '6h', ore: 6, minuti: 0 },
      { label: '8h', ore: 8, minuti: 0 },
    ],
    durateAggiunta: [
      { label: '30m', ore: 0, minuti: 30 },
      { label: '1h', ore: 1, minuti: 0 },
      { label: '2h', ore: 2, minuti: 0 },
    ],

    rules: {},
  }),

  created() {
    this.rules = {
      ...(this.getRules ? this.getRules() : {}),
      required: (v) => (v !== null && v !== '' && v !== undefined) || 'Richiesto.',
      oreValide: (v) => (v >= 0 && v <= 24) || 'Valore non valido.',
      minutiValidi: (v) => (v >= 0 && v <= 59) || 'Valore non valido.',
    };
    this.dati = this.getDatiCalendar ? this.getDatiCalendar() : {};
  },

  computed: {
    getDialog: {
      get() { return this.dialog; },
      set(value) { if (!value) this.chiudi(); },
    },

    totaleOreLabel() {
      const h = parseInt(this.dati.ore) || 0;
      const m = parseInt(this.dati.minuti) || 0;
      if (h === 0 && m === 0) return '—';
      return m > 0 ? `${h}h ${m}m` : `${h}h`;
    },
  },

  watch: {
    async dialog(val) {
      if (val) {
        this.$nextTick(() => this.$refs.formIns.resetValidation());

        await this.caricaDati();

        if (this.dati.tipoOre === 'Lavoro') {
          await this.$functions.delay(50);
          this.focusCliente();
        }
      }
    },
  },

  methods: {
    // ── Selezione tipo ──────────────────────────────────────────────
    selezionaTipo(tipo) {
      this.dati.tipoOre = tipo;
      this.impostaDescrizione();
    },

    colorePerTipo(tipo) {
      return COLORI_TIPO[tipo] || '#424242';
    },

    iconaPerTipo(tipo) {
      return ICONE_TIPO[tipo] || 'circle';
    },

    // ── Durata rapida ───────────────────────────────────────────────
    impostaDurata(ore, minuti) {
      this.dati.ore = ore;
      this.dati.minuti = minuti;
    },

    aggiungiDurata(ore, minuti) {
      let totM = (parseInt(this.dati.ore) || 0) * 60
        + (parseInt(this.dati.minuti) || 0)
        + ore * 60 + minuti;
      if (totM > 24 * 60) totM = 24 * 60;
      this.dati.ore = Math.floor(totM / 60);
      this.dati.minuti = totM % 60;
    },

    // ── Caricamento ─────────────────────────────────────────────────
    async caricaDati() {
      this.clienteSel = [];

      if (this.prog == -1) {
        if (this.sorgente) {
          // Duplicazione: riparto dai dati dell'evento originale
          this.dati = {
            data: this.data,
            prog: -1,
            codAnagrafica: this.sorgente.codAnagrafica || "",
            tipoOre: this.sorgente.tipoOre,
            daFatturare: this.sorgente.daFatturare || false,
            trasferta: this.sorgente.trasferta || false,
            descrizione: this.sorgente.descrizione,
            importo: this.sorgente.importo || 0,
            tipoImporto: this.sorgente.tipoImporto || "Orario",
            destinazione: this.sorgente.destinazione || "Cliente",
            utente: this.utente,
            ore: this.sorgente.ore,
            minuti: this.sorgente.minuti,
          };
          this.clienteSel = this.clienti.find(f => f.codAnagrafica == this.dati.codAnagrafica);
        } else {
          this.dati.data = this.data;
          this.dati.prog = this.prog;
          this.dati.codAnagrafica = "";
          this.dati.tipoOre = "Lavoro";
          this.dati.daFatturare = false;
          this.dati.trasferta = false;
          this.dati.descrizione = this.desc[0];
          this.dati.importo = 0;
          this.dati.tipoImporto = "Orario";
          this.dati.destinazione = "Cliente";
          this.dati.utente = this.utente;

          // Sabato → 4h, altrimenti 8h
          const day = new Date(this.data).getDay();
          this.dati.ore = day === 6 ? 4 : 8;
          this.dati.minuti = 0;
        }
      } else {
        try {
          const res = await get_calendar(this.data + "/" + this.prog);
          this.dati = res.data;
          // Il campo Data va confrontato/editato in formato "YYYY-MM-DD" (input type="date")
          this.dati.data = this.dati.data.substring(0, 10);
          this.clienteSel = this.clienti.find(f => f.codAnagrafica == this.dati.codAnagrafica);
        } catch (error) {
          console.log(error);
          this.$toast.info(this.$functions.getErrorMsg(error));
        }
      }
    },

    // ── Submit ──────────────────────────────────────────────────────
    async formSubmit() {
      if (this.$refs.formIns.validate() == false) return;
      this.normalizeInput();

      // Se sto modificando una voce esistente e ho cambiato la data, lo segnalo al backend
      // (che sposta la riga) invece di lasciare che salvi una copia sulla data originale.
      if (this.prog > 0 && this.dati.data !== this.data) {
        this.dati.nuovaData = this.dati.data;
        this.dati.data = this.data;
      } else {
        this.dati.nuovaData = null;
      }

      try {
        await save_calendar(this.dati);
        this.chiudi(true);
      } catch (error) {
        console.log(error);
        this.$toast.alert(this.$functions.getErrorMsg(error));
      }
    },

    normalizeInput() {
      if (this.dati.tipoOre != "Lavoro") {
        this.dati.importo = 0;
        this.dati.codAnagrafica = "";
        this.dati.destinazione = "";
      }
    },

    chiudi(aggiorna) {
      // Il dialog si nasconde ma il contenuto resta montato: se un campo (es. Cliente,
      // autofocusato all'apertura) ha ancora il focus quando chiudiamo, non riceve mai un
      // vero blur nativo e resta "bloccato" internamente come focused. Il prossimo .focus()
      // alla riapertura diventa quindi un no-op. Forzo il blur qui per resettarlo sempre.
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
      this.$emit("chiudi", aggiorna);
    },

    focusCliente() {
      // Doppio rinvio (nextTick + rAF): il campo è dentro un v-dialog con transizione,
      // un solo nextTick a volte anticipa il montaggio/layout effettivo del campo e il
      // focus() risultava "perso" nel nulla.
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.$refs.inputCliente && this.$refs.inputCliente.focus();
        });
      });
    },

    setCliente() {
      if (!this.clienteSel) {
        this.dati.importo = 0;
        this.dati.codAnagrafica = "";
        this.dati.daFatturare = false;
      } else {
        this.dati.importo = this.clienteSel.importo;
        this.dati.codAnagrafica = this.clienteSel.codAnagrafica;
        this.dati.daFatturare = true;
      }
    },

    async elimina() {
      if (this.prog == -1) return;
      const confirm = await this.$confirm.open("Elimina", "Vuoi eliminare l'evento?");
      if (!confirm) return;
      try {
        await del_calendar(this.data + "/" + this.prog);
        this.chiudi(true);
      } catch (error) {
        this.$toast.alert(this.$functions.getErrorMsg(error));
      }
    },

    impostaDescrizione() {
      this.dati.descrizione = this.desc[this.tipiOre.indexOf(this.dati.tipoOre)];
    },
  },
};
</script>

<style scoped>
.dialog-mobile {
  margin: 0 !important;
  border-radius: 0 !important;
  height: 100% !important;
}

/* ── Header ── */
.header-content {
  width: 100%;
  padding: 8px 12px;
  transition: background-color 0.25s ease;
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.header-select-wrap {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

/* Il v-select dentro l'header: testo bianco, nessun bordo */
.tipo-select {
  min-width: 140px;
  max-width: 180px;
}

.tipo-select :deep(.v-input__slot) {
  padding: 0 !important;
  box-shadow: none !important;
  min-height: 32px !important;
}

.tipo-select :deep(.v-select__selection),
.tipo-select :deep(.v-select__selection--comma) {
  color: #fff !important;
  font-weight: 700;
  font-size: 14px;
}

.tipo-select :deep(.v-icon) {
  color: rgba(255, 255, 255, 0.8) !important;
}

.header-meta {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── Section labels ── */
.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #9e9e9e;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

/* ── Totale ore ── */
.totale-ore {
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
}

/* ── Durata chip ── */
.durata-chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.durata-label {
  font-size: 11px;
  color: #9e9e9e;
}

/* ── Flag buttons (Da fatturare / Trasferta) ── */
.flag-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
  margin-right: 8px;
  margin-top: 4px;
}

.gap-8 {
  gap: 8px;
}
</style>